import request from '@/utils/request'

// 获取服务信息
export function getServer() {
  return request({
    url: '/monitor/server',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/monitor/server.js